import { Toaster } from 'sonner';
import { createPortal } from 'react-dom';

import { ABOVE_MODALS_ATTRIBUTE } from '@/components/full-screen-overlay';

// The toaster positions itself fixed, so its unstyled wrapper takes no space; the wrapper keeps toasts
// interactive above a full-screen overlay.
export const AppToaster = () =>
  createPortal(
    <div {...{ [ABOVE_MODALS_ATTRIBUTE]: '' }}>
      <Toaster
        position="top-center"
        offset={{ top: 24 }}
        visibleToasts={3}
        richColors
        duration={4000}
        style={{ display: 'flex', justifyContent: 'center' }}
        toastOptions={{ style: { width: 'fit-content' } }}
      />
    </div>,
    document.body
  );
